module.exports = __webpack_public_path__ + "static/img/link-bg-innovation.358bac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/link-bg-innovation.png
// module id = Lhkb
// module chunks = 2